var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowsCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.479 4.88672C12.0834 3.68333 11.3181 2.63554 10.292 1.89273C9.26596 1.14992 8.03157 0.75 6.76485 0.75C5.49814 0.75 4.26375 1.14992 3.23769 1.89273C2.21163 2.63554 1.44628 3.68333 1.05074 4.88672M0.75 2.48077V4.88672H3.15594M10.3738 8.49563H12.7797V10.9016M1.05074 8.49563C1.44628 9.69901 2.21163 10.7468 3.23769 11.4896C4.26375 12.2324 5.49814 12.6323 6.76485 12.6323C8.03157 12.6323 9.26596 12.2324 10.292 11.4896C11.3181 10.7468 12.0834 9.69901 12.479 8.49563",
    stroke: "#006AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsCircle);
export default __webpack_public_path__ + "static/media/arrows-circle.86cf3826.svg";
export { ForwardRef as ReactComponent };